// extracted by mini-css-extract-plugin
export default {"button1":"MyButton_button1__4fpjT"};